import UserRegister from '@Configs/schemas/UserRegister';
import { FormikErrors } from 'formik';
import * as Yup from 'yup';
import { RegisterFormStatus } from './types';

const emailRegex =
	/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;

export const registrationSchemaRegister = Yup.object().shape({
	firstname: Yup.string().required('AUTH.VALIDATE.REQUIRED.INFO'),
	email: Yup.string()
		.email('AUTH.VALIDATE.NO.VALID.EMAIL')
		.matches(emailRegex, 'AUTH.VALIDATE.NO.VALID.EMAIL')
		.required('AUTH.VALIDATE.REQUIRED.EMAIL'),
	lastname: Yup.string().required('AUTH.VALIDATE.REQUIRED.INFO'),
	// countrycodephonenumber: Yup.string().required(
	// 	'Es necesario que ingreses la información solicitada'
	// ),
	// phone_number: Yup.string()
	// 	.min(1, 'Minimum 3 symbols')
	// 	.max(50, 'Maximum 50 symbols')
	// 	.required('Es necesario que ingreses la información solicitada'),
	levelTeacher: Yup.string().required('AUTH.VALIDATE.REQUIRED.INFO'),
	password: Yup.string()
		.min(6, 'AUTH.VALIDATE.MIN.CARACTERS')
		.max(50, 'AUTH.VALIDATE.MAX.CARACTERS')
		.required('AUTH.VALIDATE.REQUIRED.PASSWORD'),
	confirmpassword: Yup.string()
		.required('AUTH.VALIDATE.REQUIRED.CONFIRMPASSW')
		.when('password', {
			is: (val: string) => (val && val.length > 0 ? true : false),
			then: Yup.string().oneOf(
				[Yup.ref('password')],
				'AUTH.VALIDATE.PASS&CONFIRMNOEQUAL'
			),
		}),
	// acceptTerms: Yup.bool().required('Debes aceptar los términos y condiciones'),
	acceptTerms: Yup.bool().oneOf([true], 'AUTH.VALIDATE.TERMS&CONDIT'),
});

const isEmailSubmitting = (status: RegisterFormStatus): boolean =>
	status?.email === 'loading';

export const getEmailError = (
	errorsObj: FormikErrors<UserRegister>,
	status: RegisterFormStatus
): string | undefined => {
	if (errorsObj.email) {
		return errorsObj.email;
	}
	if (status?.email === 'unavailable') {
		return 'AUTH.REGISTER.EMAILEXISTSERROR';
	}
};

export const hasErrors = (
	errorsObj: FormikErrors<UserRegister>,
	status: RegisterFormStatus
) => {
	const errors = Object.keys(errorsObj);
	const emailError = getEmailError(errorsObj, status);
	if (emailError) errors.push(emailError);
	return errors.length > 0;
};
